import Web from '@/components/pc/Web'
import Introduce from '@/components/pc/introduce'
import Index from '@/components/pc/index'
import Product from '@/components/pc/product'
import Download from '@/components/pc/download'
import ProductAuto from '@/components/pc/productauto'
import ProductWx from '@/components/pc/productwx'
import TimeLine from '@/components/pc/timeLine'
import Help from '@/components/pc/help'
import TicketManagement from '@/components/ticketManagement/ticketManagement'

export const pcRoutes = [{
    path: '/',
    redirect: "/web",
}, {
    path: '/ticketManagement',
    name: 'ticketManagement',
    component: TicketManagement,
}, {
    path: '/web',
    name: 'Web',
    component: Web,
    redirect: "/webindex",
    children: [{
        path: '/webindex',
        name: 'webindex',
        component: Index,
    },
    {
        path: 'webintroduce',
        name: 'webintroduce',
        component: Introduce,
    },
    {
        path: 'webproduct',
        name: 'webproduct',
        component: Product,
    }, {
        path: 'webproductauto',
        name: 'webproductauto',
        component: ProductAuto,
    }, {
        path: 'webproductwx',
        name: 'webproductwx',
        component: ProductWx,
    }, {
        path: 'webdownload',
        name: 'webdownload',
        component: Download,
    },
    {
        path: 'webtimeLine',
        name: 'webtimeLine',
        component: TimeLine,
    },
    {
        path: 'webhelp',
        name: 'webhelp',
        component: Help,
    }
    ]
}]



// WEBPACK FOOTER //
// ./src/router/pc.js